module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("adZwy"))).then(() => parcelRequire('37nVf'));